import React from 'react';
import './HeaderImage.scss';
import {Poi} from '../../react-app-env';
import {PoiMetaData} from '../../services/MetaDataService';

export interface HeaderImageProps {
  readonly poi: Poi;
  readonly metaData: PoiMetaData | null;
}

function HeaderImage({ poi, metaData }: HeaderImageProps) {
  const thumbnailImage = poi.imageUrl ?? metaData?.thumbnailUrl;
  if (!thumbnailImage) {
    return null;
  }

  return <div className="header-image"
              style={{
                backgroundImage: 'url(' + thumbnailImage + ')'
              }}>
  </div>;
}

export default HeaderImage;
